<template>
    <DynamicPopup v-if="showDynamicPopup" v-model="showDynamicPopup" @generate-standard="onStandardGenerate"
        @generate-dynamic="onDynamicGenerate"></DynamicPopup>
    <div class="loader-container" v-if="pageLoader">
        <RotatingLoader :size="30" :speed="0.6" />
        <span>Loading Details</span>
    </div>
    <div class="articles-container" v-else>
        <div class="articles-wrapper">
            <div class="articles-header" :key="refreshKey">

                <div v-if="!isCompleted && currentStage == 4" class="articles-header-completed">
                    <div class="back-btn-wrap">
                        <button class="back-btn" @click="goHome()">
                            <img :src="require('@/assets/icons/back-arrow.svg')" alt="">
                        </button>
                        <span class="home-btn-title">Article Details</span>
                    </div>
                    <div class="button-container">
                        <button v-if="false" class="share-btn" @click="showShareMenu = true">
                            <div class="completed-wrappershare">
                                <img :src="require('@/assets/icons/share.svg')"></img>
                            </div>
                        </button>
                        <button class="generate-btn" :disabled="downloadLoader" @click="downloadFinalArticle">
                            <div class="continue-btn">
                                <Svg :src="require('@/assets/icons/download.svg')" fill="white"></Svg>
                                <p>Download</p>
                                <v-progress-circular v-if="downloadLoader" indeterminate :size="18"
                                    :width="2"></v-progress-circular>
                            </div>
                        </button>
                    </div>
                </div>

                <div v-else :class="['articles-header-wrapper', { 'completed-header': isCompleted }]">
                    <button v-if="!isCompleted && currentStage != 4" class="home-btn" @click="popupType = 'goHome'">
                        <img :src="require('@/assets/icons/home.svg')" alt="">
                    </button>
                    <div class="header-title-wrapper">
                        <div class="header-title">
                            <span class="doc-title">{{ articleTitle }}</span>
                            <RenamePopup v-if="isEditing" :docName="articleTitle" :isEditing="isEditing"
                                :id="$route.params.articleId" flowType="article" @update-isEdit="isEditing = $event"
                                @updated-prTitle="articleTitle = $event" />
                            <button class="edit-btn" @click="editTitle">
                                <img :src="require('@/assets/icons/edit.svg')" />
                            </button>
                        </div>
                    </div>
                </div>

            </div>

            <div class="stage-container" :key="refresh">
                <SourceDocument v-if="currentStage === 1" :sourceList="sourceList" :flowType="'Article'"
                    :documentId="documentId" :documentType="documentType" :sectionContent="sectionContent"
                    @document-meta-selected="handleSelectedDoc" :disabled="isLocked"/>
                <SuggestArticle v-else-if="currentStage === 2" @article-selected="handleArticleSelection"
                    @suggest-article-data="handleSuggestedArticles">
                </SuggestArticle>
                <DynamicIntelligence v-else-if="currentStage === 3" v-model="dynamicQues" :subtitle="'Article'"
                    :inputId="this.$route.params.articleId" />
                <div class="completed-section" v-if="currentStage === 4">
                    <ArticleCompleted :article="articleContent" :isCompleted="isCompleted" :documenName="articleTitle">
                    </ArticleCompleted>
                </div>
            </div>

            <div v-if="currentStage != 4" class="articles-footer">
                <div class="footer-left">
                    <button class="delete-btn" @click="handleDeleteArticle"
                        :disabled="saveDraftLoader || deleteLoader || nextStageLoader">
                        <img :src="require('@/assets/icons/delete.svg')" />
                        <v-progress-circular v-if="deleteLoader" indeterminate :size="18"
                            :width="2"></v-progress-circular>
                    </button>
                    <button class="save-as-draft" @click="popupType = 'saveAsDraft'"
                        :disabled="saveDraftLoader || deleteLoader || nextStageLoader || !isDocumentSelected">
                        <v-progress-circular v-if="saveDraftLoader" indeterminate :size="18"
                            :width="2"></v-progress-circular>
                        <div v-else class="draft-wrapper">
                            <img :src="require('@/assets/icons/save.svg')" />
                            <p>Save as Draft</p>
                        </div>
                    </button>
                </div>
                <div class="footer-left">
                    <button v-if="currentStage == 1" class="generate-btn" @click="handleGenerateClick()"
                        :disabled="selectedDoc == null || sectionContent == '' || saveDraftLoader || deleteLoader || nextStageLoader">
                        <p> Generate Article Suggestions</p>
                        <img :src="require('@/assets/icons/next.svg')" alt="" />
                        <v-progress-circular v-if="nextStageLoader" indeterminate :size="18"
                            :width="2"></v-progress-circular>
                    </button>
                    <button v-else class="generate-btn" @click="handleGenerateDynamic()"
                        :disabled="saveDraftLoader || deleteLoader || nextStageLoader">
                        <p> Confirm & Continue </p>
                        <img :src="require('@/assets/icons/next.svg')" alt="" />
                        <v-progress-circular v-if="nextStageLoader" indeterminate :size="18"
                            :width="2"></v-progress-circular>
                    </button>
                </div>
            </div>
        </div>
        <v-overlay v-if="showOverlayLoader" v-model="showOverlayLoader" class="overlay" :persistent=true>
            <RotatingLoader :size="30" :speed="0.6" />
            <span>Generating</span>
        </v-overlay>
        <CommonPopup v-if="showCommonPopup" :showCommonPopup="showCommonPopup" :popupType="popupType"
            @confirm-action="handlePopupConfirmation" />
        <ConfirmPopup v-if="confirmPopup" v-model="confirmPopup" :title="popupTitle" :image="popupIcon"></ConfirmPopup>

    </div>

</template>

<script>
import axiosInstance from '@/axiosInterceptor';
import CommonPopup from '@/components/CommonPopup.vue';
import { Eventbus } from '@/plugins/eventBus';
import SourceDocument from '@/components/SourceDocument.vue';
import RenamePopup from '@/components/RenamePopup.vue';
import SuggestArticle from '../Article/SuggestArticle.vue';
import DynamicPopup from '@/components/DynamicPopup.vue';
import RotatingLoader from '@/components/CircularProgressBar.vue'
import DynamicIntelligence from '../DynamicIntelligence.vue';
import ArticleCompleted from '../Article/ArticleCompleted.vue'
import ConfirmPopup from '@/components/ConfirmPopup.vue';
import deleteImage from '@/assets/icons/delete_red.svg';
import successImage from '@/assets/icons/success.svg';
import { downloadPr } from '@/helper/downloadPr';

export default {
    name: 'ArticleStages',
    components: {
        CommonPopup, SourceDocument, RenamePopup, SuggestArticle, DynamicPopup, RotatingLoader, DynamicIntelligence, ArticleCompleted, ConfirmPopup
    },

    data() {
        return {
            showOverlayLoader: false,
            showCommonPopup: false,
            showDynamicPopup: false,
            popupType: null,
            articleTitle: null,
            saveDraftLoader: false,
            isEditing: false,
            sourceList: [],
            documentType: null,
            documentId: null,
            selectedDoc: null,
            sectionContent: '',
            currentStage: 0,
            refresh: 0,
            confirmPopup: false,
            deleteImage, successImage,
            deleteLoader: false,
            nextStageLoader: false,
            selectRules: [
                v => !!v || 'This field is required'
            ],
            dynamicQues: [],
            selectedArticle: [],
            fineTuneLoader: false,
            articleData: [],
            pageLoader: false,
            articleContent: {},
            suggestArticle: [],
            isDocumentSelected: false,
            isArticleSelected: false,
            popupIcon: null,
            popupTitle: null,
            userInputQuestions: [],
            isCompleted: false,
            downloadLoader: false,
            refreshKey: 0
        }
    },

    watch: {
        popupType() {
            if (this.popupType) {
                this.showCommonPopup = true;
            }
        }
    },

    computed: {
    },


    methods: {
        goHome() {
            this.$router.push({ name: 'ArticleHome' });
        },
        editTitle() {
            this.isEditing = true;
        },

        async downloadFinalArticle() {
            this.downloadLoader = true;

            const payload = {
                articleId: this.$route.params.articleId,
                flowType: "ARTICLE"
            }
            await downloadPr(payload, this.downloadArticleTitle);
            this.downloadLoader = false;
        },

        handleDeleteArticle() {
            this.popupType = 'delete'
            this.showCommonPopup = true;
        },

        async onStandardGenerate() {
            this.showOverlayLoader = true;
            await this.saveAsDraft();
            this.showDynamicPopup = false;
            await this.handleArticleGenerate();
            this.showOverlayLoader = false;
        },

        async onDynamicGenerate() {
            this.showDynamicPopup = false;
            this.smartGenerate = true;
            await this.saveAsDraft();
            this.generateDynamicQn();
        },
        async generateDynamicQn() {
            this.showOverlayLoader = true;
            let payload = {
                articleId: this.$route.params.articleId,
                selectedArticle: {
                    title: this.selectedArticle.title,
                    summary: this.selectedArticle.summary,
                    value: this.selectedArticle.value,
                    angle: this.selectedArticle.angle,
                    cta: this.selectedArticle.cta
                }
            }
            payload.serviceType = 'DYN_ARTICLE';
            axiosInstance.post('/article/dynamicQuestions', payload)
                .then((response) => {
                    this.dynamicQues = response.data.data.questions;
                    this.isDynamicQnGenerated = true;
                    this.smartGenerate = false;
                    this.getArticleData();
                })
                .catch((error) => {
                    Eventbus.emit('commonSnackbar', {
                        snackType: 'error',
                        message: 'Failed to generate dynamic questions',
                    });
                })
                .finally(() => {
                    this.smartGenerate = false;
                    this.showOverlayLoader = false;
                    this.refresh += 1;
                })
        },

        handleCommonPopup() {
            this.popupTitle = '';
            this.popupIcon = '';
            this.confirmPopup = true;
        },

        async handlePopupConfirmation(val) {
            this.showCommonPopup = false;
            if (val === 'yes') {
                if (this.popupType === 'delete') {
                    axiosInstance.put('/article/delete', { articleId: this.$route.params.articleId })
                        .then((response) => {
                            this.popupTitle = 'Article discarded';
                            this.popupIcon = this.deleteImage;
                            this.confirmPopup = true;
                            setTimeout(() => {
                                this.confirmPopup = false;
                                this.$router.push({ name: 'ArticleHome' });
                            }, 1000);

                        })
                        .catch((error) => {
                            Eventbus.emit('commonSnackbar', {
                                snackType: 'error',
                                message: 'Error deleting article',
                            });
                        })
                }
                else if (this.popupType === 'saveAsDraft') {
                    await this.saveAsDraft('draft');
                }
                else {
                    this.$router.push({ name: 'ArticleHome' });
                }
            }
            this.popupType = null;
        },

        async saveAsDraft(btnType) {
            this.saveDraftLoader = true;
            let endpoint = '/article/saveDraft'
            let payload = {
                articleId: this.$route.params.articleId,
            }

            if (this.currentStage === 1) {
                let documentData = {};
                if (!this.isDocumentSelected) {
                    documentData.section = null;
                    documentData.documentId = null;
                    documentData.documentType = null;
                } else {
                    documentData.section = this.sectionContent;
                    documentData.documentId = this.documentId;
                    documentData.documentType = this.documentType;
                }

                payload.lastUpdatedStage = 'SOURCE_DOC';
                payload.documentData = documentData
            } else if (this.currentStage === 2) {
                if (this.isArticleSelected) {
                    payload.selectedArticle = {
                        title: this.selectedArticle.title
                    }
                }

                payload.lastUpdatedStage = 'SUGGEST_ARTICLE';
                payload.suggestedArticleData = this.suggestArticle;

            } else if (this.currentStage === 3) {
                payload.lastUpdatedStage = 'DYN_ARTICLE';
                payload.dynamicContentWithQuestion = {
                    articleDynamicQuestions: this.dynamicQues
                }
            }
            await axiosInstance.put(endpoint, payload)
                .then((response) => {
                    if (btnType === 'draft') {
                        this.popupTitle = 'Article Draft Saved';
                        this.popupIcon = this.successImage;
                        this.confirmPopup = true;
                        setTimeout(() => {
                            this.confirmPopup = false;
                            this.$router.push({ name: 'ArticleHome' });
                        }, 1000);
                    }
                })
                .catch((error) => {
                    console.error('[ERROR] ', error);
                    Eventbus.emit('commonSnackbar', {
                        snackType: 'error',
                        message: 'Failed to save changes',
                    });
                })
                .finally(() => {
                    this.saveDraftLoader = false;
                })

            this.saveDraftLoader = false;
        },

        async handleSelectedDoc(doc) {
            this.isDocumentSelected = true
            this.documentType = doc.sourceType;
            this.documentId = doc.documentId;
            this.selectedDoc = doc.selectedDocument;
            this.sectionContent = doc.selectedSection;
        },

        async handleSuggestedArticles(suggestedArticles) {
            this.suggestArticle = suggestedArticles;
        },

        async handleGenerateDynamic() {
            if (this.currentStage === 2) {
                this.showDynamicPopup = true;
            }
            else {
                this.showOverlayLoader = true;
                await this.saveAsDraft();
                this.showDynamicPopup = false;
                await this.handleArticleGenerate();
                this.showOverlayLoader = false;
            }
        },
        async handleGenerateClick() {
            this.showOverlayLoader = true;
            try {
                await this.saveAsDraft();
                const articleId = this.$route.params.articleId;
                const payload = {
                    documentType: this.documentType,
                    documentId: this.documentId,
                    articleId: articleId,
                    sectionContent: this.sectionContent,
                };
                const response = await axiosInstance.post('/article/suggest', payload);
                if (response.status === 201) {
                    this.getArticleData();
                }
            } catch (error) {
                console.error("Error generating Article", error);
                Eventbus.emit('commonSnackbar', {
                    snackType: 'error',
                    message: 'Something went wrong, Please try again!',
                });
            } finally {
                this.refresh += 1;
                this.showOverlayLoader = false;


            }
        },

        async handleArticleGenerate() {
            this.showOverlayLoader = true;

            let payload = {
                articleId: this.$route.params.articleId,
            }
            try {
                const response = await axiosInstance.post('/article/generate', payload)
                if (response.status === 200) {
                    this.isCompleted = true;
                    this.refreshKey += 1;
                    this.getArticleData();
                }


            } catch (error) {
                console.error("Error generating aricle:", error);
                if (error.response?.status === 502 || error.code === 'ERR_NETWORK' || error.response?.status === 504) {
                    let attempts = 0;
                    let maxAttempts = 40;
                    const intervalTime = 15000;
                    const intervalId = setInterval(async () => {
                        attempts++;
                        try {
                            let isFallback = true;
                            await this.getArticleData(isFallback);
                            if (this.articleData && this.articleData.status === 'COMPLETED') {
                                clearInterval(intervalId);
                                this.isCompleted = true;
                                this.refreshKey += 1;
                            } else if (attempts >= maxAttempts) {
                                clearInterval(intervalId);
                                this.showOverlayLoader = false;

                            }
                        } catch (pollError) {
                            console.error("Error during polling:", pollError);
                            clearInterval(intervalId);
                            this.showOverlayLoader = false;
                            Eventbus.emit('commonSnackbar', {
                                snackType: 'error',
                                message: 'Failed to generate PR. Please try again later.'
                            });
                        }
                    }, intervalTime);
                }

            } finally {
                this.showOverlayLoader = false;
            }


        },

        async getDocuments() {
            const response = await axiosInstance.get('/document')
            if (response.status === 200) {
                this.sourceList = response.data.data
            }
            else {
                Eventbus.emit('commonSnackbar', {
                    snackType: 'error',
                    message: 'Something went wrong, Please try again!',
                });
            }

        },
        async getArticleData(isFallback = false) {
            if(!isFallback) {
                this.pageLoader = true;
            }
            try {
                const response = await axiosInstance.get(`/article/${this.$route.params.articleId}`);
                if (response.status === 200) {
                    this.articleData = response.data.data;
                    this.articleTitle = this.articleData.articleDocumentName;
                    this.selectedArticle = response.data.data.selectedArticle;
                    this.suggestArticle = response.data.data.suggestArticles;
                    this.documentId = this.articleData.selectedDocument.documentId
                    this.documentType = this.articleData.selectedDocument.documentType
                    this.sectionContent = this.articleData.selectedDocument.section

                    this.dynamicQues = response.data.data?.dynamicContentWithQuestion?.articleDynamicQuestions;

                    this.articleContent = response.data.data.articleContent;
                    this.userInputQuestions = [
                        this.$route.params.articleId
                    ].filter(Boolean).join("\n\n");
                    if (this.articleContent?.articleTitle !== null && this.articleContent.baseArticle !== null) {
                        const match = this.articleContent.baseArticle.match(/<h1[^>]*>(.*?)<\/h1>/i);
                        this.downloadArticleTitle = match ? match[1].trim() : '';
                        this.currentStage = 4;
                    }
                    else if (Array.isArray(this.dynamicQues) && this.dynamicQues.length > 0) {
                        this.isDocumentSelected = true;
                        this.currentStage = 3;
                    }
                    else if (this.suggestArticle?.articleOne !== null && this.suggestArticle?.articleTwo !== null && this.suggestArticle?.articleThree !== null) {
                        this.isDocumentSelected = true;
                        this.currentStage = 2;
                    } else {
                        this.currentStage = 1;
                    }

                }
            } catch (error) {
                Eventbus.emit('commonSnackbar', {
                    snackType: 'error',
                    message: 'Error fetching article details',
                });
            } finally {
                this.refresh += 1
                this.pageLoader = false;

            }

        },
        handleArticleSelection(selectedArticle) {
            this.selectedArticle = selectedArticle;
            this.isArticleSelected = true;
        },


    },

    mounted() {
        this.isLocked = history.state?.locked === true;
        this.getArticleData();
        this.getDocuments();
    }
}
</script>

<style scoped>
.articles-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background: var(--dark-background);
    background-size: 100% 100%;
}

.articles-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
}

.articles-header {
    position: sticky;
    top: 0;
    right: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: #FFFFFF14;
    color: white;
    z-index: 100;
}

.articles-header-wrapper {
    width: 56%;
    display: flex;
    justify-content: space-between;
    gap: 4.5rem;
    padding: 1rem 2rem;
}

.articles-header-completed {
    display: flex;
    justify-content: space-between;
    gap: 4.5rem;
    padding: 1rem 30px;
}

.completed-header {
    width: 100%;
    display: flex;
    justify-content: center;

}

.back-btn-wrap {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    justify-content: center;
    align-items: center;
}


.home-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FFFFFF1F;
    border-radius: 8px;
    padding: 10px;
}

.back-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FFFFFFFF;
    border-radius: 50%;
    height: 2.5rem;
    width: 2.5rem;
}

.header-title-wrapper {
    display: flex;
    justify-content: space-between;
}

.header-title {
    display: flex;
    align-items: center;
    gap: 16px;
    color: white;
}

.doc-title {
    font-weight: 500;
    text-align: center;
}

.home-btn-title {
    font-weight: 500;
    text-align: center;
    font-size: 18px;
}

.edit-btn {
    display: flex;
    padding: 10px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
    align-items: center;
    cursor: pointer;
}

.button-container {
    display: flex;
    flex-direction: row;
    gap: 1rem;
}

.share-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px;
    gap: 12px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
}

.completed-wrappershare {
    display: flex;
    align-items: center;
    gap: 0.5em;
}

.stage-container {
    display: flex;
    flex-direction: column;
    overflow: auto;
    scrollbar-width: thin;
    will-change: transform;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
}

.completed-section {
    display: flex;
    height: 100%;
    flex-direction: column;
    align-items: center;
}

.articles-footer {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 2rem;
    background: #180914;
    border-top: 1px solid #FFFFFF33;
    color: white;
    z-index: 100;
}

.footer-left {
    display: flex;
    gap: 1em;
    align-items: center;
}

.delete-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 12px 8px 12px;
    gap: 12px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
    font-size: 14px;
}

.save-as-draft {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 24px 8px 24px;
    gap: 12px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
}

.save-as-draft p {
    font-size: 14px;
}

.generate-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding: 8px 20px;
    border-radius: 8px;
    background: var(--primary-gradient-with-black);
}


.continue-btn {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
}

.overlay {
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    z-index: 9999;
}

.overlay :deep(.v-overlay__content) {
    display: flex;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
    gap: 1rem;
}

.draft-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
}
</style>